import MCButton from '@/components/ui/Buttons/MobicomButton'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import { TanCreateReq } from '@/services/mobi-api/sim/types'
import { IMG_URL } from '@/utils/constants'
import useIntl from '@/utils/intl'
import { Close } from '@mui/icons-material'
import { Dialog, Divider, Slide, TextField } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import Image from 'next/image'
import React, { FunctionComponent } from 'react'

interface Props {
  onClick: (req?: TanCreateReq) => void
}

const SelfSimInfo: FunctionComponent<Props> = ({ onClick }) => {
  const [simNum, setSimNum] = React.useState('')
  const [dialog, setDialog] = React.useState(false)
  const { translate } = useIntl()

  const Transition = React.forwardRef(function Transition (
    props: TransitionProps & {
      children: React.ReactElement<any, any>
    },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction='up' ref={ref} {...props} />
  })
  const handleChange = (value: string): void => {
    if (value.length < 10) {
      setSimNum(value)
    }
  }
  const handleNext = (): void => {
    onClick({ imsi: simNum })
  }
  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-[75vh] md:w-fit flex flex-col justify-start relative'>
      <div className='p-4 md:p-8 flex w-full flex-col gap-8 mb-10 flex-grow overflow-scroll'>
        <div className='md:w-96'>
          <span className='text-textHigh font-bold'>{translate('sim.connect')}</span>
          <p className='text-textMid text-sm font-medium'>{translate('sim.self.guide')}</p>
        </div>
        <Image draggable={false} width={100} height={100} src={IMG_URL + '/uploads/icons/selfSim.png'} alt='selfSim' className='w-32' />
        <TextField
          value={simNum}
          type='number'
          id='outlined-basic'
          label='***********F'
          variant='outlined'
          onChange={(e) => { handleChange(e.target.value) }}
          className='w-full rounded-lg border-secondaryMainStroke bg-surfaceInverse text-textHigh md:w-96'
          inputProps={{ inputMode: 'numeric' }}
          InputLabelProps={{
            style: { color: 'var(--color-text-textHigh)' }
          }}
          InputProps={{
            style: {
              color: 'var(--color-text-textHigh)',
              '&::placeholder': {
                color: 'var(--color-text-secondaryHighStroke)'
              }
            } as any
          }}
          sx={{
            '& fieldset': {
              borderRadius: '8px'
            }
          }}
        />
      </div>
      <div className='fixed md:sticky bottom-0 right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <DarkButton fullwidth onClick={handleNext} disabled={simNum.length < 9}>{translate('continue')}</DarkButton>
      </div>
      <Dialog
        open={dialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setDialog(false)}
        aria-describedby='alert-dialog-slide-description'
      >
        <div className=''>
          <div className='flex justify-end mt-3 mr-3'>
            <div className='text-textHigh bg-white/10 p-2 rounded-xl cursor-pointer' onClick={() => setDialog(false)}>
              <Close />
            </div>
          </div>
          <div className='px-14 pb-14 flex flex-col gap-6 items-center'>
            <Image draggable={false} width={1000} height={1000} className='w-fit h-fit' src={IMG_URL + '/uploads/icons/mobot.svg'} alt='mobot' />
            <div>
              <h1 className='text-textHigh font-bold text-xl text-center'>{translate('dan.title')}</h1>
              <p className='text-textMid text-sm font-medium text-center'>{translate('dan.announce')}</p>
            </div>
          </div>
          <Divider />
          <div className='px-8 pb-8 pt-4'>
            <MCButton fullwidth onClick={() => onClick()}>{translate('accept')}</MCButton>
          </div>
        </div>
      </Dialog>
    </div>
  )
}
export default SelfSimInfo
